


















































































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { finalize, debounceTime } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import $Api from '@api'
import {
    RepaymentPageRecord,
    PartRepaymentData,
    TallyBillApproveRecord,
    CalculationToFactTimeParams,
    PartRepaymentRequest,
    LoanRepaymentRequest
} from '@/api/model/repayment'
import * as JMath from '@/utils/math'
import store from '@/store'

@Component
export default class ManualFormComponent extends Vue {
    @Prop() private msg!: string

    @Prop() visible!: boolean

    disabledSubmit = false
    calculateDataLoading = false
    calculateData: any = [{}]
    unpaidDataLoading = false
    unpaidData: PartRepaymentData[] = []
    type = 1
    bizId = 0
    remark = ''
    factTime = 0
    record!: RepaymentPageRecord
    recordTallyBill!: TallyBillApproveRecord

    @Emit('close')
    handleClose(): void {
        this.remark = ''
        this.disabledSubmit = false
    }

    @Emit('refresh')
    handleRefresh(): void {}

    fetchData(record: RepaymentPageRecord): void {
        this.record = record
        const { lid, rid, tenantId, indexs, shouldTime, ..._ } = record
        const factTime = +shouldTime
        this.factTime = +shouldTime

        this.queryRepayment({ lid, indexs })
        this.queryCalculation({ lid, rid, tenantId, indexs, factTime })
    }

    fetchDataByTallyBill(record: TallyBillApproveRecord): void {
        this.recordTallyBill = record

        const { lid, rid, tenantId, indexs, shouldTime, ..._ } = record
        const factTime = +shouldTime
        this.factTime = +shouldTime
        this.type = 2
        this.bizId = record.bizId
        this.queryRepayment({ lid, indexs })
        this.queryCalculation({ lid, rid, tenantId, indexs, factTime })
    }

    queryRepayment(params: PartRepaymentRequest): void {
        this.unpaidDataLoading = true
        $Api.repaymentService
            .partRepaymentLoadData(params)
            .pipe(
                finalize(() => {
                    this.unpaidDataLoading = false
                })
            )
            .subscribe(data => {
                this.unpaidData = [{ ...data }]
                const [calculateItem] = this.calculateData
            })
    }

    queryCalculation(params: CalculationToFactTimeParams): void {
        this.calculateDataLoading = true
        $Api.repaymentService
            .calculationToFactTime(params)
            .pipe(
                finalize(() => {
                    this.calculateDataLoading = false
                })
            )
            .subscribe(
                data => {
                    const { paidAmount, ...rest } = data
                    if (!this.calculateData[0]) {
                        this.calculateData = [{}]
                    }
                    const [calculateItem] = this.calculateData
                    calculateItem.paidAmount = data.unpaidAmount
                    this.calculateData = [{ ...calculateItem, ...rest }]
                },
                error => {
                    Message.error(error.message)
                    this.calculateData = []
                    this.disabledSubmit = true
                }
            )
    }

    onSettlementSubmit(): void {
        const { remark } = this
        const factTime = new Date(this.factTime).getTime()
        const [{ lid, paidAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee, ...__ }] = this.calculateData
        const indexs = this.record.indexs
        const type = this.type
        const bizId = this.bizId
        const userId = store && store.state.auth.authInfo.userId
        const userName = store && store.state.auth.authInfo.displayName
        const overdueFeesAmount = overdueFee
        const params: LoanRepaymentRequest = { factTime, lid, paidAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFeesAmount, indexs, type, bizId, userId, userName }

        MessageBox.confirm(
            translate('repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm', { inputAmount: paidAmount }),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        )
            .then(() => {
                $Api.repaymentService.loanRepaymentToFactTime(params).subscribe(
                    data => {
                        Message.success(translate('repayment.unpaid.manualDialog.onPartialPaidSubmit.success') as string)
                        this.handleClose()
                        this.handleRefresh()
                    },
                    error => {
                        Message.error(error.message)
                    }
                )
            })
            .catch(() => {})
    }

    onDateTimeChange(): void {
        // console.log(this.factTime)
        const { lid, rid, tenantId, indexs, ..._ } = this.record
        const factTime = new Date(this.factTime).getTime()
        this.queryCalculation({ lid, rid, tenantId, indexs, factTime })
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }
}
